import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { brandingService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type UseRemoveBrandingMutationProps = {
	companyId: string;
	onSuccess?: Function;
	onError?: Function;
	refetch?: Function;
};

const useRemoveBrandingAgentOfficeMutation = ({
	companyId,
	onSuccess,
	onError,
	refetch,
}: UseRemoveBrandingMutationProps) => {
	const dispatch = useDispatch();

	return useMutation(
		() => {
			return brandingService.deleteDocumentLogoAgentOffice({
				companyId,
			});
		},
		{
			onSuccess() {
				refetch?.();
				onSuccess?.(null);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: "Couldn't delete a Logo",
					}),
				);
				onError?.(error);
			},
		},
	);
};

export default useRemoveBrandingAgentOfficeMutation;
